export const GET_PRODUCTS = 'products';
export const GET_PRODUCTS_BY_LABEL = 'products/products_by_label';
export const PRODUCTS_SEARCH = 'products/search';
export const LOGIN = 'customers/login';
export const TIMESLOTS = 'customers/timeslots'
export const GET_ANNONCEMENTS = 'announcements';
export const GET_ANNONCEMENT_FEATURED = 'announcements/featured';
export const GET_WHATSUP_NON_FEATURED_ITEMS = 'whatsup/non-featured-items';
export const GET_CATEGORIES = 'categories/getcategories';
export const SEARCH_CATEGORIES = 'categories/search';
export const GET_FAVORITE_PRODUCTS ='products/favorite';
export const GET_FAVORITE_PRODUCTS_SEARCH = 'products/favorite/search';
export const GET_FAVORITE_PRODUCTS_WITHOUT_LIMIT='products/getfavorites';
export const ADD_FAVORITE_PRODUCTS ='products/addfavorite';
export const DEL_FAVORITE_PRODUCTS ='products/removefavorite';
export const ADD_TO_CART = 'checkout/cart';
export const GET_GST = 'checkout/getgst';
export const CART = 'checkout';
export const CART_DELETE_ITEM = 'checkout/cart';
export const SUBMIT_ORDER = 'orders';
export const EDIT_ORDER = 'orders/edit';
export const SUBMIT_CUSTOMER_ORDER = 'orders/submit';
export const ORDER_DETAILS = 'orders/getordersdetails';
export const SAVE_ACCOUNT = 'customers/savedetails';
export const GET_PENDING_ORDERS = 'orders/pending-orders';
export const REPEAT_ORDER = 'orders/repeat';
export const QUOTE_ITEMS = 'quotes/items';
export const QUOTE = 'quotes';
export const INVOICE = 'sales';
export const QUOTE_PDF = 'quotes/pdf';
export const INVOICE_PDF = 'sales/pdf';
export const INVOICE_ITEMS = 'sales/items';
export const DISTRICT_MANAGER_ORDERS = 'orders/district_manager';
export const CLEAR_CART = 'checkout/clearcart';
export const GET_BRANCHES = 'sales/hq_branches';
export const GET_INVOICE_DETAILS = 'sales/hq_billing_report';
export const GET_PRODUCT_BASED_CATEGORY = 'sales/hq_product_analysis';
export const GET_SETTINGS = 'settings';
export const GET_CUSTOMER_DETAILS = 'customers/fetchcustomer';